module.exports = __webpack_public_path__ + "static/media/Excadrill_gaussian2.c8ddd5cb.png";